(ns lupapalvelu.application.foreman
  (:require [sade.strings :as ss]))

(defn tj-document->fullname [tj-document]
  (let [henkilotiedot (some-> tj-document :data :henkilotiedot)
        firstname     (some-> henkilotiedot :etunimi :value)
        lastname      (some-> henkilotiedot :sukunimi :value)
        fullname      (ss/trim-join " " firstname lastname)]
    fullname))

(defn foreman-document->role [foreman-doc]
  (some->> foreman-doc :data :kuntaRoolikoodi :value))

(defn tj-document->email [tj-document]
  (some-> tj-document :data :yhteystiedot :email :value))

(defn tj-document->phone-number [tj-document]
  (some-> tj-document :data :yhteystiedot :puhelin :value))

(defn tj-document->responsibilities
  "Returns a list of keywords for selected responsibilities + value of other field"
  [tj-document]
  (let [tasks         (some-> tj-document :data :vastattavatTyotehtavat)
        include-other (and (true? (get-in tasks [:muuMika :value]))
                           (ss/not-blank? (get-in tasks [:muuMikaValue :value])))
        selected-keys (->> tasks
                           (filter (comp boolean :value second))
                           keys
                           (remove #{:muuMika})
                           (remove #(and (= % :muuMikaValue) (not include-other))))]
    (mapv (fn [k]
            (if (= k :muuMikaValue)
              (get-in tasks [:muuMikaValue :value])
              k))
          selected-keys)))

(defn tj-document->foreman-consent [tj-document]
  (some-> tj-document :data :foremanConsent :value))

(defn with-submit-settings-defaults [settings]
  (merge-with merge
              {:notification {:acknowledge  true
                              :approve      false
                              :give-verdict true}
               :application  {:approve      false
                              :give-verdict true}}
              settings))
